import { styled, Text, View } from "tamagui";

const KeyText = styled(Text, {
  name: "KeyText",
  variants: {
    variant: {
      default: {
        color: "$gray-800",
        fontFamily: "$body",
      },
    },
    size: {
      lg: {
        fontSize: "$3",
        fontWeight: "$6",
        lineHeight: "$3",
        top: 1,
        left: 7,
      },
      md: {
        fontSize: "$1",
        fontWeight: "$6",
        lineHeight: "$1",

        top: 2,
        left: 5,
      },
      sm: {
        fontSize: "$0.8",
        fontWeight: "$6",
        lineHeight: "$0.8",
        top: 1.67,
        left: 4.75,
      },
    },
  } as const,
  defaultVariants: {
    variant: "default",
    size: "md",
  },
});

const KewWrapper = styled(View, {
  name: "KewWrapper",
  variants: {
    variant: {
      default: {
        position: "relative",
      },
    },
    size: {
      lg: {
        height: "$4.1",
        width: "$4",
      },
      md: {
        height: "$3.3",
        width: "$3",
      },
      sm: {
        height: "$2.8",
        width: "$2.5",
      },
    },
  } as const,
  defaultVariants: {
    variant: "default",
    size: "md",
  },
});

type KeyIconSize = "lg" | "md" | "sm";

const keyIconSizes = new Map<KeyIconSize, { width: number; height: number }>([
  ["lg", { width: 30, height: 34 }],
  ["md", { width: 24, height: 28 }],
  ["sm", { width: 22, height: 24 }],
]);

type KeyIconProps = {
  size?: KeyIconSize;
  width?: number;
  height?: number;
  stroke?: string;
};

const KeyIcon: React.FC<KeyIconProps> = ({
  size = "md",
  stroke = "#7D8291",
  ...props
}) => {
  const iconSize = keyIconSizes.get(size)!;
  const radius = 4;
  const offset = 4;
  const strokeWidth = 1.5;
  const half = strokeWidth / 2;
  const width = props.width ?? iconSize.width;
  const height = props.height ?? iconSize.height;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x={half}
        y={offset + half}
        width={width - strokeWidth}
        height={height - offset - strokeWidth}
        rx={radius}
        fill="white"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <rect
        x={half}
        y={half}
        width={width - strokeWidth}
        height={height - offset - strokeWidth}
        rx={radius}
        fill="white"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export const Key: React.FC<{
  text: string | number;
  disabled?: boolean;
  size?: "lg" | "md" | "sm";
  iconProps?: KeyIconProps;
}> = ({ text, disabled, iconProps, size = "md" }) => (
  <KewWrapper size={size} position={"relative"}>
    <KeyText size={size} disabled={disabled} position="absolute">
      {text}
    </KeyText>
    <KeyIcon
      size={size}
      stroke={disabled ? "#E4E7EB" : "#7D8291"}
      {...iconProps}
    />
  </KewWrapper>
);
